import { PromotionGaiaOracleGate } from './PromotionGaiaOracleGate'

export default PromotionGaiaOracleGate
// eslint-disable-next-line import/export
export * from './PromotionGaiaOracle'
